import { Injectable } from '@angular/core';

import { AppContext, AppContextType } from '@efficiently/models';

import { AppContextService } from '@efficiently/client-api-app-context';

@Injectable()
export class AppContextStoreService implements AppContextService {
	private navigationAppContext: AppContext | null = null;
	private currentAppContext: AppContext = { type: AppContextType.Global };

	public getAppContext(): AppContext {
		return this.navigationAppContext ?? this.currentAppContext;
	}

	public setNavigationContext(ctx: AppContext | null): void {
		this.navigationAppContext = ctx;
	}
	public setCurrentContext(ctx: AppContext): void {
		this.currentAppContext = ctx;
	}
}
